var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconGitHubSolid = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 24,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 .28a12 12 0 0 0-3.72 23.41h.28a1 1 0 0 0 .972-.61 1.05 1.05 0 0 0 .088-.45v-1.3a.5.5 0 0 0-.19-.33.5.5 0 0 0-.41-.1c-2.69.58-3.26-1.1-3.29-1.21A4.64 4.64 0 0 0 4 17.5l-.15-.11a.73.73 0 0 1 .38-.07 1.48 1.48 0 0 1 1.14.88 3 3 0 0 0 4 1.16.53.53 0 0 0 .3-.36 2 2 0 0 1 .56-1.22.5.5 0 0 0 .15-.53.49.49 0 0 0-.42-.35c-2.37-.27-4.8-1.1-4.8-5.19a4 4 0 0 1 1.06-2.78.49.49 0 0 0 .09-.52A3.56 3.56 0 0 1 6.32 6a5.6 5.6 0 0 1 2.52 1.15.48.48 0 0 0 .42.06A10.7 10.7 0 0 1 12 6.85a10.3 10.3 0 0 1 2.75.36.46.46 0 0 0 .41-.06A5.5 5.5 0 0 1 17.68 6a3.54 3.54 0 0 1 0 2.38.48.48 0 0 0 .1.52 4 4 0 0 1 1.05 2.75c0 4.1-2.43 4.92-4.81 5.18a.49.49 0 0 0-.42.35.49.49 0 0 0 .15.52 2.23 2.23 0 0 1 .61 1.75v3.18a1.06 1.06 0 0 0 .37.82 1.18 1.18 0 0 0 1.06.19A11.999 11.999 0 0 0 12 .28"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 24,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 .28a12 12 0 0 0-3.72 23.41h.28a1 1 0 0 0 .972-.61 1.05 1.05 0 0 0 .088-.45v-1.3a.5.5 0 0 0-.19-.33.5.5 0 0 0-.41-.1c-2.69.58-3.26-1.1-3.29-1.21A4.64 4.64 0 0 0 4 17.5l-.15-.11a.73.73 0 0 1 .38-.07 1.48 1.48 0 0 1 1.14.88 3 3 0 0 0 4 1.16.53.53 0 0 0 .3-.36 2 2 0 0 1 .56-1.22.5.5 0 0 0 .15-.53.49.49 0 0 0-.42-.35c-2.37-.27-4.8-1.1-4.8-5.19a4 4 0 0 1 1.06-2.78.49.49 0 0 0 .09-.52A3.56 3.56 0 0 1 6.32 6a5.6 5.6 0 0 1 2.52 1.15.48.48 0 0 0 .42.06A10.7 10.7 0 0 1 12 6.85a10.3 10.3 0 0 1 2.75.36.46.46 0 0 0 .41-.06A5.5 5.5 0 0 1 17.68 6a3.54 3.54 0 0 1 0 2.38.48.48 0 0 0 .1.52 4 4 0 0 1 1.05 2.75c0 4.1-2.43 4.92-4.81 5.18a.49.49 0 0 0-.42.35.49.49 0 0 0 .15.52 2.23 2.23 0 0 1 .61 1.75v3.18a1.06 1.06 0 0 0 .37.82 1.18 1.18 0 0 0 1.06.19A11.999 11.999 0 0 0 12 .28"
  })));
});
export default SvgIconGitHubSolid;
export const raw = __webpack_public_path__ + "static/media/IconGitHubSolid.077ab10fb7a109bf9640876b1d19e018.svg";